<ion-toolbar color="light">
  <ion-buttons slot="start">
    <ion-button (click)="cancel()">Cancel</ion-button>
  </ion-buttons>

  <ion-title class="ion-text-center">Send Custom Notification</ion-title>

  <ion-buttons slot="end">
    <ion-button color="primary" (click)="send()">Send</ion-button>
  </ion-buttons>
</ion-toolbar>
<ion-content class="ion-no-padding">
  <ion-grid>
    <ion-row class="notification-type-row">
      <ion-col>
        <!-- Dropdown for type of notification -->
        <ion-item lines="none">
          <ion-select 
            interface="popover"
            [interfaceOptions]="{
              size: 'auto', 
              alignment: 'center', 
              side: 'bottom'
            }"
            [value]="notificationType"
            (ionChange)="updateSelectedType($event)"
            [disabled]="true"
            >
            <div slot="label">Type</div>
            <ion-select-option [value]="notificationTypes.Email">Email</ion-select-option>
            <ion-select-option [value]="notificationTypes.Push">Push</ion-select-option>
            <ion-select-option [value]="notificationTypes.Text">Text</ion-select-option>
          </ion-select>
        </ion-item>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <ng-container *ngIf="!isLoading && notificationForm">
          <form [formGroup]="notificationForm">
            <ion-grid>
              <!-- FROM -->
              <!-- <ion-row>
                <ion-col>
                  <ion-item 
                    lines="none" 
                    class="segment-filter ion-no-padding" 
                    [disabled]="true">
                    <ion-input formControlName="from" style="text-align: right">
                      <div slot="label">From:</div>
                    </ion-input>
                  </ion-item>
                </ion-col>
              </ion-row> -->
              <!-- RODEO EVENTS -->
              <ng-container *ngIf="rodeo">
                <!-- <ion-row>
                  <ion-col>
                    <ion-item
                      [detail]="false"
                      lines="none"
                      class="segment-filter ion-no-padding"
                      id="select-rodeo-events"
                      style="cursor: pointer"
                      [disabled]="rodeoEvents.length <= 1"
                    >
                      <ion-label>Classes</ion-label>
                      <div slot="end">
                        <ion-chip
                          *ngIf="notificationForm.value.rodeoEvents.length === 0; else rodeoEventNames">None</ion-chip>
                        <ng-template #rodeoEventNames>
                          <ion-chip>{{notificationForm.value.rodeoEvents.length}} selected</ion-chip>
                        </ng-template>
                      </div>
                    </ion-item>
                    <ion-popover #rodeoEventPopover
                      trigger="select-rodeo-events"
                      class="popover-autofill"
                      [showBackdrop]="false" 
                      [translucent]="false" 
                      side="bottom"
                      size="cover">
                      <ng-template>
                        <app-typeahead
                          title="Select Rodeo Events"
                          [items]="rodeoEvents"
                          [selectedItems]="selectedRodeoEvents"
                          [allowMultiple]="true"
                          (selectionChange)="classesChanged($event)"
                        ></app-typeahead>
                      </ng-template>
                    </ion-popover>
                  </ion-col>
                </ion-row> -->
                <!-- SCHEDULES -->
                <!-- <ion-row>
                  <ion-col>
                    <ion-item lines="none" class="segment-filter ion-no-padding">
                      <ion-select 
                        interface="popover"
                        [interfaceOptions]="{
                          size: 'auto', 
                          alignment: 'start', 
                          side: 'bottom'
                        }"
                        (ionChange)="schedulesChanged($event)"
                        [multiple]="true"
                        [(ngModel)]="selectedSchedules"
                        [ngModelOptions]="{ standalone: true }"
                        [disabled]="schedules.length === 0">
                        <div slot="label">Schedules</div>
                        <ion-select-option *ngFor="let schedule of scheduleNameOptions" [value]="schedule">{{schedule}}</ion-select-option>
                      </ion-select>
                    </ion-item>
                  </ion-col>
                </ion-row> -->
                <!--TODO: DISCIPLINES -->
                <!-- <ion-row>
                  <ion-col>
                  </ion-col>
                </ion-row> -->
              </ng-container>
              <!-- VIEWING ACCOUNT GROUP ACCOUNTS LIST -->
              <ng-container *ngIf="accounts && !rodeo">
                <!-- CC EMAILS -->
                <ion-row>
                  <ion-col>
                    <ion-item
                      [detail]="false"
                      lines="none"
                      class="segment-filter ion-no-padding"
                      id="ccEmails-popover"
                      style="cursor: pointer"
                      [disabled]="true"
                    >
                      <ion-label>Recipients</ion-label>
                      <div slot="end" id="select-accounts">
                        <ion-chip
                          *ngIf="selectedAccounts.length === 0; else accountNames">None</ion-chip>
                        <ng-template #accountNames>
                          <ion-chip>{{selectedAccounts.length}}</ion-chip>
                        </ng-template>
                      </div>
                    </ion-item>
                    <ion-popover 
                      #ccAccountsPopover 
                      trigger="ccEmails-popover"
                      class="popover-autofill"
                      [showBackdrop]="false" 
                      [translucent]="false" 
                      side="bottom"
                      size="cover"
                    >
                      <ng-template>
                        <!-- In order to allow multiple: usePopover = false (displays as modal && shows 'Done' to apply selected changes) -->
                        <app-typeahead
                          title="Select Recipients"
                          dynamicSearchMode="accounts"
                          [selectedItems]="selectedAccounts"
                          [usePopover]="true"
                          [allowMultiple]="true"
                          (selectionChange)="accountsChanged($event)"
                        ></app-typeahead>
                      </ng-template>
                    </ion-popover>
                  </ion-col>
                </ion-row>
              </ng-container>
              <!-- SUBJECT / TITLE -->
              <ion-row>
                <ion-col>
                  <ion-item lines="none" class="segment-filter ion-no-padding">
                    <ng-container *ngIf="notificationType === notificationTypes.Email; else pushOrText">
                      <ion-input formControlName="subject">
                        <div slot="label">Subject:</div>
                      </ion-input>
                    </ng-container>
                    <ng-template #pushOrText>
                      <ion-input formControlName="title">
                        <div slot="label">Title:</div>
                      </ion-input>
                    </ng-template>
                  </ion-item>
                </ion-col>
              </ion-row>
              <!-- BODY -->
              <ion-row>
                <ion-col>
                  <ion-item lines="none" class="segment-filter ion-no-padding">
                    <ion-textarea formControlName="body" [autoGrow]="true" rows="6">
                      <div slot="label">Message:</div>
                    </ion-textarea>
                  </ion-item>
                </ion-col>
              </ion-row>
              <!-- NOTIFICATION TYPE: TEXT / PUSH FORM -->
              <!-- IMAGE URLS -->
              <!-- TODO: -->
              <!-- <ion-row>
                <ion-col>
                  
                </ion-col>
              </ion-row> -->
            </ion-grid>
          </form>
        </ng-container>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
